import React, { useEffect, useState } from 'react';
import MembershipTypeController from '../controllers/MembershipTypeController'
import CreateMembershipCommand from '../models/membership/CreateMembershipCommand'
import { Controller, useForm, FormProvider } from "react-hook-form";
import PacmanLoader from "react-spinners/PacmanLoader";
import { useParams } from 'react-router-dom';
import Select from 'react-select'
import MembershipTypeViewModel from '../models/membershipTypes/MembershipTypeViewModel';
import MemberCard from './membership/CreateMembership/MemberCard'
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import MembershipController from "../controllers/MembershipController"
import { MembershipViewModel, DefaultMembershipViewModel } from '../models/membership/MembershipViewModel';
import moment from 'moment'
import MemberController from '../controllers/MemberController'
import { SignInToEventCommand } from '../models/member/SignInToEventCommand/SignInToEventCommand'

export default function EditMembership() {
    let { membershipId } = useParams<{ membershipId: string }>();
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [hasMultipleMembers, setHasMultipleMembers] = useState<boolean | null>(null);
    const [membershipTypes, setMembershipTypes] = useState<MembershipTypeViewModel[]>();
    const [membership, setMembership] = useState<MembershipViewModel>();
    const [firstLoad, setFirstLoad] = useState(true);
    const membershipController = new MembershipController();
    const membershipTypeController = new MembershipTypeController();
    const [keyNumber, setKeyNumber] = useState<number>();
    const defaultValues: CreateMembershipCommand = {
        Membership: DefaultMembershipViewModel()
    }
    const methods = useForm<CreateMembershipCommand>({ defaultValues });
    const { control,
        register,
        handleSubmit,
        getValues,
        reset,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        watch
    } = methods;

    useEffect(() => {
        if (membershipTypes == null) {
            getMembershipTypes();
        }
        if (membershipTypes != null && membership == null) {
            getMembership();
        }
        if (membership && firstLoad) {
            assignMembership();
        }
    })

    const memberController = new MemberController();

    const addNote = async () => {
        setSubmitLoading(true);
        var memberId = membership?.Members[0].Id;
        if (memberId) {
            var note = prompt("Please enter your note")
            if (note) {
                await memberController.AddNoteToMember({ MemberId: memberId, Note: note });
                var notes = getValues(`Membership.Notes`);
                if (!notes) {
                    notes = [];
                }
                notes.push({ Date: moment(new Date()).format("ddd DD MMM yyyy"), Note: note })
                setValue("Membership.Notes", notes);
            }
        }
        setSubmitLoading(false);
    }


    const assignMembership = () => {
        if (membership) {
            membership.Members.forEach((member) => {
                var date = moment(member.DateOfBirth).format("yyyy-MM-DD");
                member.Thumbprints = [];
                member.DateOfBirth = date;
            });
            reset({ Membership: membership });
            setFirstLoad(false);
        }
    }

    const getMembership = async () => {
        var result = await membershipController.GetMembership(membershipId)
        if (result != null) {
            var type = membershipTypes?.filter((type) => type.Id == result?.MembershipTypeId)[0];
            if (type) {
                setHasMultipleMembers(type.MultipleMembers)
            }
            setMembership(result);
        }
        setLoading(false);
    }
    const getMembershipTypes = async () => {
        var result = await membershipTypeController.List()
        if (result != null) {
            setMembershipTypes(result);


        }
        setLoading(false);
    }


    const editMember = async (data: CreateMembershipCommand) : Promise<MembershipViewModel | undefined> => {
        setSubmitLoading(true);
        var result = false;
        if (data.Membership.Members.some(function (member) {
            return !member.HasFingerprint && (!member.Thumbprints || member.Thumbprints.length == 0);
        })) {
            result = window.confirm("Are you sure you don't want to capture any fingerprints?");
        }
        else {
            result = true;
        }
        if (result) {
            try {
                var controller = new MembershipController();
                var createResult = await controller.EditMembership(data, setError);
                return createResult;
            }
            catch (err) {
                console.log(err);
            }
            finally {
                setSubmitLoading(false);
            }
        }
        else {
            setSubmitLoading(false);
        }
        return
    }
    
    const onSubmit = async (data: CreateMembershipCommand) => {
        var createResult = await editMember(data);
        if (createResult) {
            window.location.href = ("/");
        }
    };

    const signIn = async (data: CreateMembershipCommand) => {
        var createResult = await editMember(data);
        var result = true;
        if (createResult) {
            await Promise.all(createResult.Members.map(async (member) => {
                if(member.Id)
                {
                    var model: SignInToEventCommand = {
                        MemberId: member.Id,
                        UseLoyalty: false,
                        KeyNumber: keyNumber ?? 0,
                        PaidMembership: data.Membership.MembershipPaid
                    };
                    result = await memberController.SignIn(model) && result;
                }
                else
                {
                    result = false;
                }
            }));      
            if(result){
                window.location.href = ("/");
            }
        }
           
    }

    if (loading) {
        return <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
    }

    const onSelectionChange = (val: MembershipTypeViewModel) => {
        setHasMultipleMembers(val.MultipleMembers)
    }

    const membershipDue = (dueDate: Date) => {

        if (moment(dueDate) > moment(new Date())) {
            return false;
        }
        return true;
    }

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">New Membership</h1>
            <br />
            <FormProvider {...methods}>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label">Membership Type</label>
                        <Controller control={control} name="Membership.MembershipTypeId" render={({ field: { onChange, value, name, ref } }) => (
                            <Select className="text-dark"
                                inputRef={ref}
                                options={membershipTypes}
                                value={membershipTypes && membershipTypes.find(c => c.Id === value)}
                                onChange={(val: any) => { console.log(val); onChange(val.Id); onSelectionChange(val) }}
                                getOptionLabel={(option: MembershipTypeViewModel) => option.Name}
                                getOptionValue={(option: MembershipTypeViewModel) => option.Id} />
                        )} />
                    </div>
                    <div className="mb-3 form-check">
                        <input {...register("Membership.IsGuest")} type="checkbox" className="form-check-input" />
                        <label className="form-check-label">Guest?</label>
                    </div>
                    <div className="mb-3 form-check">
                        <input {...register("Membership.IsSwinging")} type="checkbox" className="form-check-input" />
                        <label className="form-check-label">Swinging?</label>
                    </div>
                    <div className="mb-3 form-check">
                        <input {...register("Membership.IsFetish")} type="checkbox" className="form-check-input" />
                        <label className="form-check-label">Fetish?</label>
                    </div>
                    <div className="mb-3 form-check">
                        <input {...register("Membership.IsBlocked")} type="checkbox" className="form-check-input" />
                        <label className="form-check-label">Barred?</label>
                    </div>
                    {membership && membershipDue(membership.MembershipDue) &&
                        <div className="mb-3 form-check">
                            <input {...register("Membership.MembershipPaid")} type="checkbox" className="form-check-input" />
                            <label className="form-check-label">Paid Membership?</label>
                        </div>}
                    <input {...register("Membership.MembershipDue")} value={moment(getValues("Membership.MembershipDue")).format("DD-MM-yyyy")} hidden />



                    {hasMultipleMembers != null &&
                        <div className="mb-3">
                            <Accordion defaultActiveKey="0">
                                <MemberCard {...{ control, register, defaultValues, getValues, setValue, errors, clearErrors, hasMultipleMembers, watch, isEditing: true }} />
                            </Accordion>
                            <div className="card bg-light text-dark">
                                <div className="card-body">
                                    <button type="button" className="btn btn-dark" onClick={addNote}>Add Note</button>
                                    {getValues("Membership.Notes") &&
                                        <table className="table">
                                            <tbody>
                                                {getValues("Membership.Notes") && getValues("Membership.Notes").map((note, index) => {
                                                    return <tr key={index.toString()}>
                                                        <td className="col-3">{moment(note.Date).format("ddd DD MMM yyyy")}</td>
                                                        <td style={{ textAlign: "left" }}>{note.Note}</td>
                                                    </tr>
                                                })}
                                            </tbody>
                                        </table>
                                    }
                                </div>
                            </div>
                            <br />
                            {submitLoading ?
                                <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
                                :
                                <>
                                    <button className="btn btn-lg btn-light float-start" type="submit">Submit</button>
                                    <div className="float-end">
                                        <div className="row">
                                            <div className="col">
                                                <input value={keyNumber} onChange={(e) => setKeyNumber(Number(e.target.value))} type="text" className="form-control form-control-lg" placeholder="Key Number" />
                                                <label htmlFor="floatingInput" className="text-dark">Key Number</label>
                                            </div>
                                            <div className="col">
                                                <button className="btn btn-lg btn-light" onClick={() => signIn(getValues())}>Sign In</button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    }
                </form>
            </FormProvider>
        </div >
    );
}